import { produce } from 'immer';
import {
  CLEAR_CART_STATUS,
  FETCH_CART_STATUS,
  FETCH_CART_STATUS_FULFILLED,
  FETCH_CART_STATUS_REJECTED,
  REPLACE_CART_STATUS,
} from 'b2b-apps/shop/cart/redux/cartStatus/actionTypes';
import {
  CartStatusActions,
  CartStatusState,
} from 'b2b-apps/shop/cart/redux/cartStatus/types';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import { CartStatusType } from 'b2b-common/core/cart/api/CartTypes';

const initialData: CartStatusType = {
  count: 0,
  lastInsertedQuantity: null,
  messages: [],
  value: 0,
  isLastInsertedNewItem: false,
};

const initialState: CartStatusState = Object.assign(
  RemoteRecordData.getDefault(),
  {
    data: initialData,
  },
);

const reducer = (
  state: CartStatusState = initialState,
  action: CartStatusActions,
): CartStatusState => {
  switch (action.type) {
    case CLEAR_CART_STATUS:
      return RemoteRecordData.fulfill(initialData);

    case FETCH_CART_STATUS:
      return produce(state, (draft: CartStatusState) => Object.assign(RemoteRecordData.init(), {
        data: draft.data,
      }));

    case FETCH_CART_STATUS_FULFILLED:
    case REPLACE_CART_STATUS:
      return RemoteRecordData.fulfill(action.payload.data);

    case FETCH_CART_STATUS_REJECTED:
      return RemoteRecordData.reject(action.payload.error);

    default:
      return state;
  }
};

export { reducer };
